import type { ImportQualityReviewAction } from "../api/imports";

/** Explicit user statements, stored verbatim in the existing audited comment. */
export function importReviewReasons(action: ImportQualityReviewAction | null) {
  const labels = action === "resolve_plausible" ? [
    "Rabatt erklärt die Abweichung",
    "Preiseinheit erklärt die Abweichung",
    "Rundung erklärt die Abweichung",
  ] : action === "mark_correction_required" ? [
    "Menge oder Einheit falsch übernommen",
    "Preis oder Betrag falsch übernommen",
    "Original ist nicht eindeutig",
    "Abweichung steht bereits im Original",
  ] : [];
  return labels.map((label) => ({ value: label, label }));
}

export function reviewDecisionComment(reason: string, note: string): string {
  return [reason, note.trim()].filter(Boolean).join(". ");
}
